export default "__VITE_ASSET__DZSK5t2L__$_?nuxt_component=async&nuxt_component_name=IconFunctionIconsMitWolle&nuxt_component_export=default__"